import { render, staticRenderFns } from "./TransactionContent.vue?vue&type=template&id=7c232d9d&lang=pug"
import script from "./TransactionContent.vue?vue&type=script&lang=js"
export * from "./TransactionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports